import { render, staticRenderFns } from "./AutoPaymentReviewComponent.vue?vue&type=template&id=0ef06559&"
import script from "./AutoPaymentReviewComponent.vue?vue&type=script&lang=js&"
export * from "./AutoPaymentReviewComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports